module.exports = __webpack_public_path__ + "img/open-result-icon-step-01.673c378b.png";